export function isNumber(value) {

  const _value = value.trim();

  if (_value.trim() === '') {
    return false;
  }

  return !isNaN(_value);

}